"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_responsive_1 = require("react-responsive");
const Button_1 = require("./Button");
const colors_1 = require("../styles/colors");
const typography_1 = require("../styles/typography");
class Dialog extends React.Component {
    constructor(props) {
        super(props);
        this.node = undefined;
    }
    render() {
        let { dialogText, buttonPrimaryText, buttonSecondaryText, containerStyle, buttonStyle, childStyle, primaryOnClick, secondaryOnClick, isOpen, targetParent, overlayStyle, } = this.props;
        let container = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            background: colors_1.white,
        };
        let button = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 80,
            width: '100%',
        };
        let child = Object.assign({}, typography_1.text, typography_1.medium);
        let buttons;
        const Fragment = React.Fragment;
        let overRideWidth;
        this.node = (React.createElement(Fragment, null,
            React.createElement(react_responsive_1.default, { maxDeviceWidth: 767 }, matches => {
                if (matches) {
                    child = Object.assign({}, child, { width: 295, lineHeight: '24px', margin: '24px 24px 8px 24px' });
                    container = Object.assign({}, container, { width: 343 });
                    overRideWidth = buttonSecondaryText !== undefined ? 139 : 295;
                }
                else {
                    child = Object.assign({}, child, { width: 320, lineHeight: '24px', margin: '24px 32px 8px 32px' });
                    container = Object.assign({}, container, { width: 384 });
                    overRideWidth = buttonSecondaryText !== undefined ? 152 : 320;
                }
                child = Object.assign({}, child, childStyle);
                container = Object.assign({}, container, containerStyle);
                button = Object.assign({}, button, buttonStyle);
                let childElem = React.createElement("div", { style: child }, dialogText);
                if (buttonSecondaryText !== undefined) {
                    buttons = (React.createElement("div", { style: button },
                        React.createElement(Button_1.default, { text: buttonSecondaryText, size: "large", type: "secondary", onClick: secondaryOnClick, overrideWidth: overRideWidth, style: {
                                outerStyle: {
                                    marginRight: 8,
                                },
                            } }),
                        React.createElement(Button_1.default, { text: buttonPrimaryText, size: "large", type: "primary", onClick: primaryOnClick, overrideWidth: overRideWidth, style: {
                                outerStyle: {
                                    marginLeft: 8,
                                },
                            } })));
                }
                else {
                    buttons = (React.createElement("div", { style: button },
                        React.createElement(Button_1.default, { text: buttonPrimaryText, size: "large", type: "primary", onClick: primaryOnClick, overrideWidth: overRideWidth })));
                }
                return (React.createElement("div", { style: Object.assign({ width: '100%', height: '100%', zIndex: 2, position: 'absolute', top: 0, left: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.2)' }, overlayStyle) },
                    React.createElement("div", { style: container },
                        childElem,
                        buttons)));
            })));
        return ReactDOM.createPortal(this.node, document.getElementById(targetParent));
    }
}
exports.default = Dialog;
